<script lang="ts">
	import type { ApexOptions } from 'apexcharts';
	import type { PublicDay } from '../../AppTypes';
	import Chart from '../Chart.svelte';

	export let days: PublicDay[] = [];

	$: points = days
		.filter((d) => d.avgResponseTimeMs !== null)
		.map((d) => ({ x: new Date(d.day).getTime(), y: d.avgResponseTimeMs as number }));

	$: chartOptions = {
		chart: {
			type: 'area',
			height: 160,
			fontFamily: 'inherit',
			foreColor: '#94a3b8',
			toolbar: { show: false },
			zoom: { enabled: false },
			animations: { enabled: false }
		},
		series: [{ name: 'Avg response time', data: points }],
		colors: ['#3b82f6'],
		dataLabels: { enabled: false },
		stroke: { curve: 'smooth', width: 2 },
		fill: { type: 'gradient', gradient: { shadeIntensity: 1, opacityFrom: 0.35, opacityTo: 0.05, stops: [0, 100] } },
		grid: { borderColor: 'rgba(148,163,184,0.2)', strokeDashArray: 4 },
		markers: { size: 0, hover: { size: 4 } },
		xaxis: { type: 'datetime', labels: { datetimeUTC: false }, axisBorder: { show: false }, axisTicks: { show: false } },
		yaxis: { labels: { formatter: (v: number) => `${Math.round(v)} ms` } },
		tooltip: {
			theme: 'dark',
			x: { format: 'MMM dd' },
			y: { formatter: (v: number) => `${Math.round(v)} ms` }
		}
	} as ApexOptions;
</script>

{#if points.length > 0}
	<Chart options={chartOptions} />
{:else}
	<p class="text-sm text-gray-400 py-6 text-center">No response-time data yet.</p>
{/if}
